/****************************************************
 * Module Name:  addDocumentTypeModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { Component } from "react";
import { LoadingButton } from "@mui/lab";
import { Form, Modal } from "react-bootstrap";
import { Box, Button, TextField } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

import CommonSnackbar from "../common/commonSnackBar";
import logo from '../../images/pansuriya.jpg'
import Constants from "../../utility/constants";
import Utility from "../../utility/utility";
import DocumentTyeProxy from "../../utility/proxy/manager/documentTypeProxy";
import SaveIcon from '@mui/icons-material/Save';

export default class AddDocumentTypeModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            newType: this.props.editOperation ? this.props.sourceData.type : "",
            newdescription: this.props.editOperation
                ? this.props.sourceData.description
                : "",
            showError: false,

            validateTypePresentSpinner: false,
            typeAvailable: true,
            showValidationMessage: false,
            typeValidationError: "",
        }
    }

    closeErrorDialog = () => {
        this.setState({
            showError: false,
        });
    };

    validateTypePresent = (typeEntered) => {
        if (!typeEntered || typeEntered.trim() === "") return;

        this.setState({
            validateTypePresentSpinner: true,
        });

        DocumentTyeProxy.CheckDocumentTypeAvailable(
            typeEntered,
            (response) => {
                //if we got response that means documentType is present at backend
                if (response) {
                    //Document Type already present
                    this.setState({
                        validateTypePresentSpinner: false,
                        showValidationMessage: true,
                        typeAvailable: false,
                    });
                } else {
                    //Document Type not available, so can be used
                    this.setState({
                        validateTypePresentSpinner: false,
                        showValidationMessage: true,
                        typeAvailable: true,
                    });
                }
            }
        );
    }

    handleSave = () => {
        let data = {
            id: this.props.editOperation ? this.props.sourceData.id : undefined,
            type: this.state.newType,
            description: this.state.newdescription,
        };

        if (this.props.handleSave) {
            if (this.props.handleValidation) {
                if (this.props.handleValidation(data)) this.props.handleSave(data);
                else
                    this.setState({
                        showError: true,
                    });
            } else this.props.handleSave(data);
        }
    };

    buttonDisable = () => {
        if (!this.props.editOperation)
            return (
                !this.state.showValidationMessage || !this.state.typeAvailable
            );

        return false;
    };

    render() {
        return (
            <Box>
                <CommonSnackbar
                    show={this.state.showError}
                    message={
                        <Box>
                            Add Document Type validation Failed
                            <br /> Please enter complete data
                        </Box>
                    }
                    variant={"error"}
                    autoHide={false}
                    handleClose={this.closeErrorDialog}
                    title="Validation Failure"
                />

                <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;
                            {this.props.editOperation
                                ? "Edit Document Type"
                                : "Add New Document Type"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <center>
                            <table style={{ width: "100%" }}>
                                <tbody>
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>
                                                <Form.Label>Document Type Id</Form.Label>
                                            </td>
                                            <td>
                                                <Form.Label>{this.props.sourceData.id}</Form.Label>
                                            </td>
                                        </tr>
                                    )}
                                    {this.props.editOperation && (
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td>
                                            <Form.Label>
                                                Document Type <sup style={{ color: "red" }}>*</sup>
                                            </Form.Label>
                                        </td>
                                        {this.props.editOperation ? (
                                            <td>
                                                <Form.Label>{this.state.newType}</Form.Label>
                                            </td>
                                        ) : (
                                            <td>
                                                <TextField
                                                    margin="normal"
                                                    fullWidth
                                                    size="small"
                                                    label="Document Type (required)"
                                                    placeholder="Enter Document Types"
                                                    value={this.state.newType}
                                                    autoFocus
                                                    onBlur={(e) =>
                                                        this.validateTypePresent(
                                                            this.state.newType
                                                        )
                                                    }
                                                    onChange={(e) =>
                                                        this.setState({
                                                            newType: e.target.value,
                                                            showValidationMessage: false,
                                                            typeValidationError: Utility.CheckIsPresent(
                                                                e.target.value
                                                            )
                                                                ? ""
                                                                : "Document Type Cannot be Empty",
                                                        })
                                                    }
                                                    helperText={this.state.typeValidationError}
                                                    error={this.state.typeValidationError.length > 0}
                                                />
                                            </td>
                                        )}
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>
                                            {this.state.validateTypePresentSpinner ? (
                                                <CircularProgress size="1rem" />
                                            ) : !this.state.showValidationMessage ? (
                                                <Box>&nbsp;</Box>
                                            ) : this.state.typeAvailable ? (
                                                <font color="green">Document Type available</font>
                                            ) : (
                                                <font color="red">Document Type not available</font>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label>Description</Form.Label>
                                        </td>
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Description"
                                                placeholder="Enter Description"
                                                value={this.state.newdescription}
                                                onChange={(e) =>
                                                    this.setState({ newdescription: e.target.value })
                                                }
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </center>
                    </Modal.Body>
                    <Modal.Footer>
                        <LoadingButton
                            loading={this.props.loading}
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                            variant="contained"
                            onClick={() => this.handleSave()}
                            disabled={this.buttonDisable()}
                            sx={{ mr: 1 }}
                        >
                            Save
                        </LoadingButton>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={this.props.handleClose}
                            disabled={this.props.loading}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Box>
        );
    }
}